import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const root = css`
  display: flex;
  flex-direction: column;
`

export const toggleAllContainer = css`
  display: flex;
  flex-direction: row;
  align-items: start;
`

export const checkboxes = css`
  padding-left: ${size[32]};
`

export const hidden = css`
  display: none;
`
